import React, { PureComponent } from 'react';
import { css } from '@emotion/css';
import { theme } from '@branchjs/neo-components';

import Button from '../../../../../common/components/core/Button';

import { DA_CREATOR_BUTTON_COPY } from '../../discoAdsConstants';

const styles = {
  buttonContainer: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '28px',
    marginTop: '16px',
    minWidth: '340px',
  }),
  cancelButton: css({
    marginRight: '12px',
    borderColor: theme.colors.primary.main,
    color: theme.colors.primary.main,
  }),
  saveAndContinueButton: css({}),
};

const getSaveButtonTestId = (buttonCopy) => {
  const { SAVE } = DA_CREATOR_BUTTON_COPY;
  if (buttonCopy === undefined) {
    return 'save-and-continue';
  }
  if (buttonCopy === SAVE) {
    return 'save';
  }
  return 'launch';
};

class DiscoAdsButtonsWrapper extends PureComponent {
  render() {
    const { buttonContainer, cancelButton, saveAndContinueButton } = styles;

    const { saveAndContinueButtonIsDisabled, onSaveClick, saveButtonCopy, onCancelClick } = this.props;

    return (
      <div className={buttonContainer}>
        <Button testid="cancel" type="secondary" className={cancelButton} onClick={onCancelClick}>
          Cancel
        </Button>
        <Button
          testid={getSaveButtonTestId(saveButtonCopy)}
          className={saveAndContinueButton}
          disabled={saveAndContinueButtonIsDisabled}
          onClick={onSaveClick}
        >
          {saveButtonCopy ? saveButtonCopy : DA_CREATOR_BUTTON_COPY.SAVE_AND_CONTINUE}
        </Button>
      </div>
    );
  }
}

export default DiscoAdsButtonsWrapper;
